import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const WorkoutCompleteModal = ({ open, totalElapsed, calories, onRestart }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          className="bg-card border border-primary rounded-2xl p-10 max-w-md w-full text-center"
        >
          <CheckCircle className="h-20 w-20 text-primary mx-auto mb-6" />
          <h2 className="font-heading text-4xl text-white uppercase tracking-wider mb-4">Workout Complete!</h2>
          <p className="text-muted-foreground text-lg mb-2">You crushed it! 💪</p>
          <div className="flex justify-center gap-8 mb-8">
            <div className="text-center">
              <p className="font-heading text-3xl text-primary">{formatTime(totalElapsed)}</p>
              <p className="text-muted-foreground text-sm">Duration</p>
            </div>
            <div className="text-center">
              <p className="font-heading text-3xl text-primary">{calories}</p>
              <p className="text-muted-foreground text-sm">Calories</p>
            </div>
          </div>
          <div className="flex gap-4">
            <Button
              onClick={onRestart}
              variant="outline"
              className="flex-1 h-12 border-white/20 text-white hover:bg-white/10 font-heading tracking-wider"
            >
              Restart
            </Button>
            <Link to="/dashboard" className="flex-1">
              <Button className="w-full h-12 bg-primary text-primary-foreground font-heading tracking-wider">
                Dashboard
              </Button>
            </Link>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
